<template>
    <div class="wrapper">
        <div id="marks-container" class="marks-container">
            <div class="intro-text">
                <span>Beoordeel alle {{ marks.length }} onderwerpen en krijg het cijfer van jouw jonko!</span>
            </div>
            <form-item 
                v-for="(mark, index) in marks"
                :id="`form-item-${index}`"
                :key="mark.subject"
                class="form-item"
                :class="[index == 0 ? 'first' : '', index == marks.length-1 ? 'last' : '']"
                :mark="mark"
                :index="index"
                @ratingUpdated="handleRatingUpdated"
                @inputEnded="handleInputEnded"></form-item>
        </div>
        <div class="footer">
            <div class="progress-bar" :class="computedProgress == '100%' ? 'calculate-rating-button' : ''" @click="handleRateJoint">
                <div class="progress-track">
                    <span class="progress" v-html="computedProgress !== '100%' ? computedProgress : 'Cijfer berekenen'"></span>
                </div>
                <div class="progress-green-bar" :style="`width: ${computedProgress}`"></div>
            </div>
        </div>
    </div>
</template>

<script>
import FormItem from '@/components/FormItem.vue';


export default {
    name: 'App',
    components: {
        FormItem
    },
    data() {
        return {
            sliderValue: 6,
            activeMark: 0,
            marks: [
                {
                    subject: 'Mooie tip',
                    description: 'Heeft de jonko een mooi gevouwen tip? Denk aan de vorm, of mogelijke figuurtjes',
                    rating: 0,
                    maxPoints: 0.5
                },
                {
                    subject: 'Clean tip',
                    description: 'Is de tip schoon en strak gedraaid? Of zit er nog wiet of tabak tussen de tip en vloei?',
                    rating: 0,
                    maxPoints: 0.5
                },
                {
                    subject: 'Strakheid begin',
                    description: 'Hoe strak is het rond de tip? Zit de tip goed vast?',
                    rating: 0,
                    maxPoints: 1
                },
                {
                    subject: 'Strakheid midden',
                    description: 'Hoe strak is het middelste gedeelte van de joint gedraaid?',
                    rating: 0,
                    maxPoints: 1
                },
                {
                    subject: 'Strakheid einde',
                    description: 'Hoe strak is de bovenkant van de joint gedraaid?',
                    rating: 0,
                    maxPoints: 1
                },
                { // iets met party trick, bonuspunten?
                    subject: 'Afwerking insie',
                    description: 'Is het een insie? Indien dit het geval is, hoe mooi is het papier afgewerkt/-gebrand?',
                    rating: 0,
                    maxPoints: 0.5
                },
                {
                    subject: 'Cone vorm',
                    description: 'Hoeveel wordt de joint breder naarmate hij in lengte groeit?',
                    rating: 0,
                    maxPoints: 1.5
                },
                {
                    subject: 'Volume',
                    description: 'Hoe vol is de joint gevuld? Hoeveel papier is er nog aan de bovenkant over?',
                    rating: 0,
                    maxPoints: 1
                },
                {
                    subject: 'Magic stuff',
                    description: 'Hoeveel wiet/hash zit er in de joint? Zit er veel of weinig tabak bij?',
                    rating: 0,
                    maxPoints: 1, // zowel van mark als extraPoint
                    // extraPoint: {
                    //     subject: 'Kief',
                    //     description: 'Bevat de joint kief?',
                    //     maxPoints: 0.5
                    // }
                },
                {
                    subject: 'Afwerking bovenkant',
                    description: 'Hoe goed is de bovenkant afgewerkt? Kan er niks meer uitvallen?',
                    rating: 0,
                    maxPoints: 0.5
                },
                {
                    subject: 'Airflow',
                    description: 'En als laatste.. hoe goed rookt de joint? Steek aan dat ding pieter, steek aan!',
                    rating: 0,
                    maxPoints: 1
                }
            ],
            filledFormItems: [],
            apiConnection: null,
            joint: null
        }
    },
    methods: {
        handleRateJoint() {
            if(this.computedProgress !== '100%') return this.scrollToFormItem()

            const newJoint = this.getJointData();

            if(newJoint.rating == 0) {
                this.$message({ type: 'warning', message: 'Zo slecht kan hij niet zijn, toch? Laten we het opnieuw proberen' })
                this.filledFormItems = []
                setTimeout(this.scrollToTop, 500)
                return
            }

            localStorage.removeItem('marks')
            localStorage.removeItem('filled')

            this.handleApiTimeout()

            // const data = JSON.stringify(newJoint);

            // this.apiConnection.open('POST', `https://80.61.147.206:3000/joints/register`);
            // this.apiConnection.setRequestHeader('Content-Type', 'application/json');
            // this.apiConnection.timeout = 3000;
            // this.apiConnection.ontimeout = this.handleApiTimeout;
            // this.apiConnection.send(data);
        },
        getJointData() {
            let total = 0

            this.marks.forEach(mark => {
                total += parseInt(mark.rating * mark.maxPoints)
            })

            const totalPoints = eval(this.marks.map(mark => mark.maxPoints).join('+'))

            const rating = Math.round((total / totalPoints) * 10) / 10

            const timestamp = Date.now()

            const joint = {
                marks: this.marks.map(mark => parseInt(mark.rating)),
                rating,
                timestamp
            }

            this.joint = joint

            return joint
        },
        handleRatingUpdated(data) {
            const { value, index } = data
            this.marks[index].rating = value

            if(this.filledFormItems.length == 0 && index !== 0) {
                this.addSkippedIndexes(index, -1)
            }

            if(this.filledFormItems.includes(index)) return
            const lastIndex = this.filledFormItems[this.filledFormItems.length-1]
            if(lastIndex + 2 <= index) {
                const skippedFormItemsAmount = index - (lastIndex + 1)
                this.addSkippedIndexes(skippedFormItemsAmount, lastIndex)
            }
            this.filledFormItems.push(index)
        },
        handleInputEnded(index) {
            if(index == this.marks.length -1 || this.filledFormItems.length == this.marks.length) return

            setTimeout(function() {
                const container = document.getElementById('marks-container')

                const currentFormItem = document.getElementById(`form-item-${index}`)
                const nextFormItem = document.getElementById(`form-item-${index+1}`)
                const top = nextFormItem.offsetTop - (currentFormItem.getBoundingClientRect().height + 60);

                container.scrollTo({ top: top, behavior: 'smooth' })
            }, 100)
        },
        addSkippedIndexes(skippedFormItemsAmount, lastIndex) {
            for(let i = 0; i < skippedFormItemsAmount; i++) {
                this.filledFormItems.push(lastIndex+i+1)
            }
        },
        handleApiResponse() {
            const rawResponseData = this.apiConnection.response;
            if(!rawResponseData) return this.$router.push({ name: 'JointSimple', rating: this.joint.rating })
            const responseData = JSON.parse(rawResponseData);

            const localStorageRegisteredJointIds = localStorage.getItem('registeredJointIds')

            let registeredJointIds = []
            if(localStorageRegisteredJointIds) registeredJointIds = localStorageRegisteredJointIds.split(',')
            registeredJointIds.push(responseData.id)
            localStorage.setItem('registeredJointIds', registeredJointIds)

            this.$router.push({ name: 'Joint', params: { id: responseData.id } })
            localStorage.removeItem('marks')
            localStorage.removeItem('filled')
        },
        handleApiTimeout() {
            this.$router.push({ name: 'JointSimple', params: { rating: this.joint.rating } })
        },
        scrollToFormItem() {
            if(this.filledFormItems.length == 0 || this.filledFormItems.includes(this.marks.length-1)) return
            const container = document.getElementById('marks-container')

            const lastFormItem = document.getElementById(`form-item-${this.filledFormItems[this.filledFormItems.length-1]+1}`)
            const top = lastFormItem.offsetTop - 240

            container.scrollTo({ top: top, behavior: 'smooth' })
        },
        scrollToTop() {
            const container = document.getElementById('marks-container')
            container.scrollTo({ top: 0, behavior: 'smooth' })
        }
    },
    created() {
        const localStorageMarks = localStorage.getItem('marks')
        const localStorageFilled = localStorage.getItem('filled')
        if(!localStorageMarks || !localStorageFilled) return
        this.marks = JSON.parse(localStorageMarks)
        this.filledFormItems = JSON.parse(localStorageFilled)
    },
    mounted() {
        this.scrollToFormItem()

        // this.apiConnection = new XMLHttpRequest();
        // this.apiConnection.addEventListener("load", this.handleApiResponse);

        const formItems = document.querySelectorAll('.form-item')

        const options = {
            root: null,
            treshold: 0,
            rootMargin: `-120px`
        }

        const observer = new IntersectionObserver(function(entries) {
            entries.forEach(entry => {
                const element = entry.target
                if(entry.isIntersecting == false && entry.boundingClientRect.top < 0) return element.classList.add("animate-from-top") // element left the top of the screen
                if(entry.isIntersecting == false && entry.boundingClientRect.top > visualViewport.height-120) return element.classList.add("animate-from-bottom") // element left the bottom of the screen
                if(entry.isIntersecting == true && entry.boundingClientRect.top < visualViewport.height-120) {
                    return element.classList.remove("animate-from-top", "animate-from-bottom") // element is in the screen
                }
            })
        }, options)

        formItems.forEach((el) => {
            observer.observe(el);
        })
    },
    computed: {
        computedProgress: function() {
            localStorage.setItem('marks', JSON.stringify(this.marks))
            localStorage.setItem('filled', JSON.stringify(this.filledFormItems))
            return `${parseInt(this.filledFormItems.length * (100 / this.marks.length))}%`
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';

$margin-sides: 9px;

.wrapper {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    user-select: none;

    .marks-container {
        position: relative;
        width: 100vw;
        height: calc(100vh - 200px);
        overflow: scroll;

        .intro-text {
            width: 80%;
            text-align: center;
            margin: 50px auto;

            span {
                color: #707070;
                font-weight: 600;
                font-size: 17px;
            }
        }

        .form-item {
            margin: 28px $margin-sides;
            opacity: 1;
            transition: transform .5s ease, opacity .2s ease;

            &.first {
                margin-top: 16px;
            }
            &.last {
                margin-bottom: 70px;
            }

            &.animate-from-top {
                transform: translateY(-20%);
                opacity: 0;
            }

            &.animate-from-bottom {
                transform: translateY(20%);
                opacity: 0;
            }
        }
    }

    .marks-container::before {
        content: "";
        position: fixed;
        width: 100%;
        height: 40px;
        background: linear-gradient(180deg, $background-color, $background-color-transparent);
        z-index: 10;
    }

    .marks-container::after {
        content: "";
        position: fixed;
        width: 100%;
        height: 40px;
        bottom: 80px;
        background: linear-gradient($background-color-transparent, $background-color);
        z-index: 10;
    }

    .footer {
        position: fixed;
        height: 80px;
        bottom: 0;
        padding: 0 $margin-sides;
        background-color: $background-color;

        .progress-bar {
            position: relative;
            width: calc(100vw - 2*$margin-sides);
            bottom: 0;
            border-radius: 12px !important;
            overflow: hidden;
            transition: transform .2s ease;

            .progress-track {
                height: 40px;
                background-color: #C4C4C430;
                text-align: center;
            }

            .progress-green-bar {
                position: absolute;
                top: 0;
                left: 0;
                height: 40px;
                background-color: #4B9E09;
                z-index: 1;
                transition: width 1s ease;
            }

            .progress {
                position: relative;
                font-size: 17px;
                font-weight: 600;
                color: #ffffff;
                top: 6px;
                z-index: 10;
            }

            &.calculate-rating-button:active {
                transform: scale(0.96);
                user-select: none;
            }
        }
    }
}

</style>
